import { C as CosmosIconPersonFollow$1, d as defineCustomElement$1 } from './p-CKI2CbYl.js';

const CosmosIconPersonFollow = CosmosIconPersonFollow$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPersonFollow, defineCustomElement };
